// Tell Vite about our CSS entry point.
import "~/css/main.css";
//
// Web Awesome theme.
// Imported here rather than in main.css so they bypass Tailwind's CSS importer,
// which cannot inline the @import url(...) statements the Web Awesome
// stylesheets chain-load each other with.
import "@awesome.me/webawesome/dist/styles/themes/default.css";
// The scroll lock every <wa-dialog> and <wa-drawer> reaches for on open. It is
// CSS rather than a style tag so a strict CSP cannot drop it, the theme does not
// chain-load it, and utilities.css would bring a whole utility framework in to
// get it, so it is imported on its own. Without it the class the overlay sets
// matches nothing and the page keeps scrolling behind the open dialog.
import "@awesome.me/webawesome/dist/styles/utilities/scroll-lock.css";
//
// Web components
import "@justinribeiro/lite-youtube";
import "@awesome.me/webawesome/dist/components/copy-button/copy-button.js";
import "@awesome.me/webawesome/dist/components/dialog/dialog.js";
import "@awesome.me/webawesome/dist/components/drawer/drawer.js";
import "@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js";
import "@awesome.me/webawesome/dist/components/dropdown/dropdown.js";
import "@awesome.me/webawesome/dist/components/format-date/format-date.js";
import "@awesome.me/webawesome/dist/components/popover/popover.js";
import "@awesome.me/webawesome/dist/components/qr-code/qr-code.js";
import "@awesome.me/webawesome/dist/components/relative-time/relative-time.js";
import "@awesome.me/webawesome/dist/components/tab-group/tab-group.js";
import "@awesome.me/webawesome/dist/components/tab-panel/tab-panel.js";
import "@awesome.me/webawesome/dist/components/tab/tab.js";
import "@awesome.me/webawesome/dist/components/toast/toast.js";
import "@awesome.me/webawesome/dist/components/tooltip/tooltip.js";
//
// Our modules and adapters around third-party libraries
import { googleTagManager, hubspot, posthog } from "~/analytics";
import * as discounts from "~/discounts";
import "~/dropzone";
import * as htmx from "~/htmx";
import "~/icons";
import logger from "~/lib/logger";
import * as pdf from "~/pdf";
import * as tagify from "~/tagify";
import "~/sentry";
import * as toasts from "~/toasts";
import "~/webawesome";
//
// Our Stimulus controllers
import "~/app";

const log = logger();

// Initializers that run on the initial page load.
discounts.init();
toasts.init();
posthog.init();
void hubspot.init();

// Initializers that run on every htmx load, including the initial page load.
htmx.onLoad((element) => {
  log.debug(Date.now(), "htmx:onLoad", {
    tag: element.tagName,
    id: element.id,
    class: element.classList.toString(),
  });
  googleTagManager.initTree(element);
  pdf.initTree(element);
  tagify.initTree(element);
});

// Prevent clicks on disabled elements, so that disabled links works like disabled buttons.
// Use the capture phase to stop the event before htmx listeners on the link get it.
document.addEventListener(
  "click",
  (e) => {
    if ((e.target as Element).closest("[disabled]")) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  { capture: true },
);
